import type { ExtractedDocumentPages } from '../../../services/goods-receiving/goods-receiving.types';

/**
 * True when the DDT extraction says the document has more pages than the
 * photos read. Old drafts carry no page info: no notice.
 */
export function hasMissingDdtPages(pages: ExtractedDocumentPages | null | undefined): boolean {
  if (!pages) {
    return false;
  }
  const printedTotalExceedsPhotos =
    pages.printedTotal !== null && pages.printedTotal > pages.photosRead;
  return printedTotalExceedsPhotos || pages.continues;
}

const APPEND_PAGES_PARAM = 'appendPages';

/** Query of the Document step opened from the "add pages" banner: new photos join the stored ones. */
export function buildAppendPagesQuery(draftId: string): string {
  return `draftId=${encodeURIComponent(draftId)}&${APPEND_PAGES_PARAM}=true`;
}

export function isAppendPagesRequested(searchParams: URLSearchParams): boolean {
  return searchParams.get(APPEND_PAGES_PARAM) === 'true';
}
